import { SmsFailedSharp } from '@mui/icons-material';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classes from './LeaveChatModal.module.css';

const LeaveChatModal = ({
  show = false,
  setShow = () => {},
  onClick = () => {},
  onClick1 = () => {},
  onHide = null
}) => {
  const { t } = useTranslation('chatBot');

  return (
    <Modal show={show} onHide={onHide || (() => setShow(false))} centered className={classes.modal}>
      <Modal.Header className={classes.header}>
        <h4>
          <SmsFailedSharp size={40} fill={`var(--primary-clr)`} /> {t('leaveChatModal.title')}
        </h4>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <p className={classes.message}>{t('leaveChatModal.message')}</p>
        <div className={classes.btnsBox}>
          <button className={classes.yesBtn} onClick={onClick}>
            {t('leaveChatModal.label1')}
          </button>
          <button className={classes.noBtn} onClick={onClick1}>
            {t('leaveChatModal.label2')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LeaveChatModal;
